import { SVGProps, Ref, forwardRef } from 'react';

export const UserDoubleOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.208 5.164c0-1.833.916-3.665 3.665-3.665S9.54 3.33 9.54 5.164 8.623 8.83 5.873 8.83 2.208 6.997 2.208 5.164m1.4 0c0-.708.18-1.267.477-1.624.26-.312.75-.641 1.788-.641s1.529.33 1.789.641c.297.357.477.916.477 1.624s-.18 1.267-.477 1.624c-.26.312-.75.642-1.789.642s-1.528-.33-1.788-.642c-.298-.357-.477-.915-.477-1.624"
                fill="currentColor"
            />
            <path
                d="M9.101 12.385c-.794-.662-1.936-.987-3.228-.987-1.291 0-2.433.325-3.227.987-.527.439-.99 1.099-1.219 2.115H0c.597-3.342 3.235-4.502 5.873-4.502s5.277 1.16 5.874 4.502H10.32c-.23-1.016-.693-1.676-1.219-2.115"
                fill="currentColor"
            />
            <path
                d="m10 8.83.095.002c2.75 0 3.666-1.833 3.666-3.666S12.845 1.5 10.096 1.5H10v1.401l.095-.001c1.038 0 1.529.33 1.789.642.297.357.477.915.477 1.624 0 .708-.18 1.267-.477 1.624-.26.312-.75.641-1.789.641H10z"
                fill="currentColor"
            />
            <path d="M10.125 9.998h.014-.029z" fill="currentColor" />
            <path
                d="M11.362 11.507c.779.146 1.461.438 1.99.878.527.439.99 1.099 1.219 2.115h1.427c-.503-2.816-2.455-4.083-4.636-4.412z"
                fill="currentColor"
            />
        </g>
    </svg>
));
UserDoubleOutlinedSize16Glyph.displayName = 'UserDoubleOutlinedSize16Glyph';
